export default {
  setTwoFactor(state, data) {
    state.isTwoFactor = data.isTwoFactor;
    state.defaultMethod = data.availableMethod[0];
    state.availableMethod = data.availableMethod;
    state.methodEnum = data.methodEnum;
    state.userSms = data.userSms;
    state.userEmail = data.userEmail;
  },
  setMFACode(state, code) {
    state.MFACode = code;
  },
  setMFACodeErr(state, MFACodeErrMSg) {
    state.MFACodeErrMSg = MFACodeErrMSg;
  },
  chooseTheMethod(state, choseMethod) {
    state.choseMethod = choseMethod;
    state.availableMethod = [...state.availableMethod].sort((a, b) =>
      a === choseMethod ? -1 : b === choseMethod ? 1 : 0,
    );
  },
  chooseAnotherMethod(state) {
    state.isChooseAnotherMethod = !state.isChooseAnotherMethod;
  },
};
